import React from 'react';

export default function ActionItems({ data }) {
  if (!data || !data.actionItems) {
    return (
      <div className="action-items">
        <p>No action items available</p>
      </div>
    );
  }

  const actionItems = Array.isArray(data.actionItems) ? data.actionItems : [];

  return (
    <div className="action-items">
      <h3>✅ Action Items</h3>

      {actionItems.length === 0 ? (
        <p>No action items found</p>
      ) : (
        <div className="action-list">
          {actionItems.map((item, idx) => (
            <div key={idx} className="action-item">
              <div className="action-header">
                <div className="action-task">
                  <strong>{idx + 1}. {item.task}</strong>
                  <span className={`priority priority-${item.priority?.toLowerCase()}`}>
                    {item.priority}
                  </span>
                </div>
              </div>
              <p className="action-details">{item.details}</p>
              <div className="action-meta">
                <span>⏱️ Time: {item.timeEstimate}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
